// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { endOfMinute as fn } from "../endOfMinute.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const endOfMinute = convertToFP(fn, 1);

// Fallback for modularized imports:
export default endOfMinute;
